import React, { useState } from 'react';
import classNames from 'classnames';

import InsertHtmlContent, {
  Props as InsertHtmlContentPropsType,
} from 'components/Common/InsertHtmlContent/InsertHtmlContent';

import styles from './TextHeader.module.scss';

export default function TextHeader({
  htmlContent,
  className,
  ...props
}: InsertHtmlContentPropsType): JSX.Element {
  const [expanded, setExpanded] = useState(false);

  function handleClick() {
    setExpanded(prev => !prev);
  }

  return (
    <InsertHtmlContent
      htmlContent={htmlContent}
      className={classNames(styles.container, className, {
        [styles.expanded]: expanded,
      })}
      onClick={handleClick}
      {...props}
    />
  );
}
